(function() { window.GUID_6c16a27a_c27c_4287_89fb_ccdcdd3ebd17 = { getGuid: function() { return "6c16a27a-c27c-4287-89fb-ccdcdd3ebd17"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let PlayerType;
        (function (PlayerType) {
            PlayerType[PlayerType["Regular"] = 0] = "Regular";
            PlayerType[PlayerType["Spare"] = 1] = "Spare";
            PlayerType[PlayerType["SpareForDivision"] = 2] = "SpareForDivision";
        })(PlayerType = Enumeration.PlayerType || (Enumeration.PlayerType = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=PlayerType.pre.js.map
